import { TCalculatorQuestion, TGetCalculatorQuestions } from 'store/calculator/types'
import { EditButton } from '..'
import { getMainCategorySelector, ApiCalculatorService } from 'store'
import { useTypedSelector } from 'hooks'
import { useTranslation } from 'react-i18next'
import {
   ButtonDelete,
   ButtonWrap,
   CloseBtn,
   DeleteBtn,
   HeadingWrap,
   ModalWrap,
   QurstionItemStyled,
   TextModal
} from './styled'
import { AxiosResponse } from 'axios'
import { KeyedMutator } from 'swr'
import { MdDeleteForever } from 'react-icons/md'
import { ModalMaterial } from 'components'
import { useState } from 'react'
import { IoClose } from 'react-icons/io5'
import { toast } from 'react-toastify'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { colors } from 'enums'
import { MdDragIndicator } from 'react-icons/md'

export const QuestionItem = ({
   item,
   mutate
}: {
   item: TCalculatorQuestion
   mutate: KeyedMutator<AxiosResponse<TGetCalculatorQuestions>>
}) => {
   const [open, setOpen] = useState(false)
   const { accessToken } = useTypedSelector((state) => state.user)
   const closeModal = () => setOpen(false)

   const onDeleteQuestionClick = async () => {
      try {
         await ApiCalculatorService.deleteCalculator(item._id, accessToken || '')
         mutate()
         closeModal()
         toast.info(t('successfullyDeleted'))
      } catch (error) {
         toast.error(t('anErrorHasOccurred'))
      }
   }
   const { t, i18n } = useTranslation()
   const lang = i18n.language
   const { categories } = useTypedSelector(getMainCategorySelector)

   const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
      useSortable({ id: item._id })

   const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      backgroundColor: isDragging ? colors.light_grey : colors.solid_white,
      zIndex: isDragging ? 2 : 'auto'
   }

   return (
      <QurstionItemStyled ref={setNodeRef} style={style}>
         <ModalMaterial isOpen={open} close={closeModal}>
            <ModalWrap>
               <HeadingWrap>
                  <h2>{t('deleteQuestion')}</h2>
                  <IoClose onClick={closeModal} />
               </HeadingWrap>
               <TextModal>{t('yourWantToDelete')}</TextModal>
               <ButtonWrap>
                  <CloseBtn onClick={closeModal}>{t('close')}</CloseBtn>
                  <ButtonDelete onClick={onDeleteQuestionClick}>
                     {t('delete')}
                  </ButtonDelete>
               </ButtonWrap>
            </ModalWrap>
         </ModalMaterial>
         <div>
            <span {...listeners} {...attributes}>
               {' '}
               <MdDragIndicator />
            </span>
         </div>
         <div>{categories?.data?.find((el) => el?._id === item?.category)?.title}</div>
         <div>
            <p>{item.title.find((el) => el.lang === lang)?.value}</p>
         </div>
         <div>
            {item.rooms.map((room, i) => (
               <p key={room + i}>{t(`${room}`)}</p>
            ))}
         </div>
         <div>
            <DeleteBtn onClick={() => setOpen(true)}>
               <MdDeleteForever />
            </DeleteBtn>
            <EditButton link={`/calculator/${item._id}`} />
         </div>
      </QurstionItemStyled>
   )
}
